import React from 'react';
import ApplicationModal from "./components/reusable/ApplicationModal";
import Alert from "./components/reusable/Alert";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ErrorPage from "./pages/ErrorPage";
import "./App.css";
import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "./store/modal/modalSlice";
import { Routes, Route } from "react-router-dom";

function App() {
  const modal = useSelector((state) => state.modal.value);
  const alert = useSelector((state) => state.alert.value);
  const dispatch = useDispatch();
  const onClickModalButton = () => {
    dispatch(closeModal());
  };
  return (
    <div className="App">
      {modal.view && (
        <div className="modal">
          <ApplicationModal
            onClickModalButton={onClickModalButton}
            modal={modal}
          />
        </div>
      )}
      <Alert alert={alert}/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup/:type" element={<Signup />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </div>
  );
}

export default App;
